import type { IRespuestaApiObjeto } from '../../globales/interfaces';
import api from '../../utils/api';
import type { ITrazabilidadTecnico } from './entidades/ITrazabilidadTecnico';

class MonitorModelo {
    constructor() { }

    public async obtenerTrazabilidadTecnico(usuarioId: number, fecha?: string | null): Promise<IRespuestaApiObjeto<ITrazabilidadTecnico[]>> {
        const { data } = await api.get(
            `/api/Monitor/ObtenerTrazabilidadTecnico`, {
            params: {
                usuarioId,
                fecha: fecha || null
            }
        });

        return data;
    }
}

export default MonitorModelo;
